/*eslint-disable prefer-const */
/*eslint-disable no-unused-vars */
/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React from 'react';
//import axios from 'axios';
import extractDomain from 'extract-domain';
import APIEndpoints from '../api/APIEndpoints';
import RetryAPI from '../api/RetryAPI';
import {
  HttpErrorCodes,
  HttpSuccessCodes,
} from '../errorhandling/HttpErrorCodes';
//import CookiesService  from './CookiesService';
import { axiosInstance } from '../../api/axios';

class HttpHeader {
  cacheBuster = (url) => `${url}?cb=${Date.now()}`;
  contructor() {
    this.cname = '';
    this.device = '';
    this.encryptionKey = '';
  }

  async getEncryptionKeyStore() {
    const keyStoreResp = null;
    let keyStoreDataResp = null;

    try {
      const keyStoreResp = await axiosInstance.get(
        this.cacheBuster(APIEndpoints.getEncryptionKeyResources()),
      );

      keyStoreDataResp = keyStoreResp.data;

      if (keyStoreResp.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200) {
        this.setEncryptionKey(keyStoreDataResp.Response.SymmetricKey);

        RetryAPI.resetRetryCount();
        RetryAPI.setResponseReceived(true);
      } else {
        RetryAPI.incrementRetryCount();
        RetryAPI.setResponseReceived(false);
        RetryAPI.setErrorCode(keyStoreResp.status);
      }
    } catch (error) {
      let errorMessage = '';
      //var requestAborted = '';

      console.log('Get Encrypted Key Store RESPONSE Exception: ', error);

      if (error) {
        errorMessage = error.toString();
        //requestAborted = errorMessage.match(/aborted/i);
        RetryAPI.setErrorCode(HttpErrorCodes.HTTP_REQUEST_ABORTED);
      }
      if (error.response) {
        console.log('Data: ', error.response.data);
        console.log('Header: ', error.response.headers);
        console.log('Status: ', error.response.status);
        RetryAPI.setErrorCode(error.response.status);
      }

      RetryAPI.incrementRetryCount();
      RetryAPI.setResponseReceived(false);
    }
    return keyStoreResp;
  }

  getEncryptionKey() {
    if (this.encryptionKey == '' || typeof this.encryptionKey == 'undefined')
      this.encryptionKey = localStorage.getItem('encryptionKey');

    return this.encryptionKey;
  }

  setEncryptionKey(encryptionKey) {
    localStorage.setItem('encryptionKey', encryptionKey);
    this.encryptionKey = encryptionKey;
  }

  getCNAME = () => {
    let hostname = '',
      url = '',
      domain = '';
    url = window.location.href;
    //url = 'http://javelina-member-portal.s3-website.us-east-2.amazonaws.com/member';
    //url = 'https://centivo-test.mphasishealthportal.com/member';
    hostname = window.location.hostname;
    console.log('window.location.href: ', url);
    console.log('window.location.hostname: ', window.location.hostname);
    if (hostname == 'localhost') {
      //this.cname = 'a1m-qa';
      this.cname = 'a1m-test';
      return this.cname;
    }

    this.domainName = extractDomain(url);
    console.log('Domain Name Before: ', this.domainName);

    if (this.domainName == 'amazonaws.com') this.cname = 'a1m-qa';
    else {
      domain = url.substring(
        url.lastIndexOf('/', url.lastIndexOf('.') - 1) + 1,
      );
      this.cname = domain.substring(0, domain.indexOf('.'));
    }
    console.log('cname: ', this.cname);
    return this.cname;
  };

  getDomainName = () => {
    let url, hostname;
    url = window.location.href;
    //url = 'http://javelina-member-portal.s3-website.us-east-2.amazonaws.com/member';
    //url = 'https://centivo-test.mphasishealthportal.com/member';
    hostname = window.location.hostname;
    if (hostname == 'localhost') {
      this.domainName = 'mphasishealthportal.com';
      // this.domainName = 'eldocomp.com';
      return this.domainName;
    }

    this.domainName = extractDomain(url);
    console.log('Domain Name Before: ', this.domainName);
    if (this.domainName == 'amazonaws.com') this.domainName = 'eldocomp.com';

    console.log('Domain Name After: ', this.domainName);
    return this.domainName;
  };

  getDevice = () => {
    this.device = 'Browser';
    return this.device;
  };

  refreshBearerToken(refreshToken) {
    let bearerToken;

    console.log('Refresh Token: ', refreshToken);
    //CookiesService.remove('loginToken');
    sessionStorage.removeItem('loginToken');

    bearerToken = refreshToken;
    const options = { path: '/' };
    sessionStorage.setItem('loginToken', bearerToken);
    //CookiesService.set('loginToken', bearerToken, options);
    //bearerToken = CookiesService.get('loginToken');
  }
}

export default new HttpHeader();
